import { Typography, useTheme } from "@material-ui/core";
import React from 'react';
import { useTranslate } from 'react-admin';

import { ConfigFileStatus } from '../../../entities/ConfigFileStatus';
import { InfoBox } from './InfoBox';

interface ConfigStatusBadgeProps {
  status: ConfigFileStatus;
}

export const ConfigStatusBadge: React.FC<ConfigStatusBadgeProps> = ({ status }) => {
  const theme = useTheme();
  const translate = useTranslate();

  return (
    <InfoBox title={translate("osfc.storage_ui.config_status.title")} style={{ marginBottom: "15px" }}>
      <div
        style={{
          padding: "8px",
          borderRadius: "4px",
          backgroundColor:
            status === ConfigFileStatus.production
              ? theme.palette.storageUi.configProduction
              : theme.palette.storageUi.configDraft,
          textAlign: "center",
        }}
      >
        <Typography
          variant="button"
          style={{ fontWeight: 800, textTransform: "uppercase", color: "#000000" }}
        >
          {status === ConfigFileStatus.production ? translate("osfc.storage_ui.config_status.production") : translate("osfc.storage_ui.config_status.draft")}
        </Typography>
      </div>
    </InfoBox>
  );
};
